<template>
  <div class="pa-3 grey lighten-4">
    <v-card class="card--flex-toolbar">
      <v-card-text class="pa-0">
        <v-form ref="form">
          <v-card-title class="grey lighten-4 pa-2">
            <h3 class="secondary--text">
              {{ $t("company.page.team.section.manage_team") }}
            </h3>
            <v-spacer></v-spacer>
            <v-btn  v-if="userRoleInCompany >= DEFINES.ROLE_ADMIN" color="success" @click="show_add_member = true" small>{{ $t("rms.button.add") }}</v-btn>
          </v-card-title>
          <!-- Member -->
          <v-card v-if="members">
            <v-data-table
              v-if="members"
              :headers="table_headers"
              :items="members"
              :search="search"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.index + 1 }}</td>
                  <td class="text-xs-left">
                    {{
                      props.item.name
                        ? props.item.name
                        : props.item.temp_user_name
                    }}
                    <v-chip
                      small
                      v-if="props.item.id == user.id"
                      color="lightteal"
                      outline
                      >{{ $t("rms.you") }}</v-chip
                    >
                  </td>
                  <td class="text-xs-left">
                    {{ DEFINES.ROLE_STR[props.item.pivot.role] }}
                  </td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">
                    <span v-if="props.item.phone"></span>
                    <span v-else>---</span>
                  </td>
                  <td class="text-xs-center">
                    <!-- show delete button only when user is admin or owner and user role is greater
                than another member of company-->
                    <ConfirmationDialog
                      v-if="
                        userRoleInCompany >= DEFINES.ROLE_ADMIN &&
                        userRoleInCompany > props.item.pivot.role
                      "
                      :desc="'company.member.remove.confirmation.description'"
                      :action="
                        getDialogAction(
                          props.item,
                          'rms_delete',
                          'error',
                          'removeMember'
                        )
                      "
                      :headline="'company.member.remove.confirmation.heading'"
                      :button_type="'icon'"
                    ></ConfirmationDialog>
                  </td>
                </tr>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                  {{
                    $t("rms.alert.search_not_found", {
                      search: this.search,
                    })
                  }}
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
          <!-- Add member -->
          <add-member-dialog
            v-if="show_add_member"
            @memberAdded="$emit('getMembers')"
            @close="show_add_member = false"
          ></add-member-dialog>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";
import AddMemberDialog from "../AddMember";
import ConfirmationDialog from "@/components/ConfirmationDialog";
export default {
  name: "CompanyTeam",
  props: {
      members: {
          type: Array,
          default: []
      }
  },
  data() {
      return {
          show_add_member: false,
          search: "",
          table_headers: [
            {
            text: i18n.t("rms.table.header.sn"),
            align: "left",
            sortable: false,
            value: "title",
            },
            {
            text: i18n.t("rms.table.header.name"),
            align: "left",
            sortable: false,
            },
            {
            text: i18n.t("rms.table.header.role"),
            align: "left",
            sortable: false,
            },
            { text: i18n.t("rms.table.header.email"), sortable: false },
            { text: i18n.t("rms.table.header.phone"), sortable: false },
            {
            text: i18n.t("rms.table.header.action"),
            sortable: false,
            align: "center",
            },
        ],
      }
  },
  computed: {
    ...mapGetters("company", {
        selected_company_id: "getSelected",
    }),
    ...mapState({
      user: (state) => state.user.profile,
    }),
    userRoleInCompany() {
        return this.$store.getters["company/userRoleInCompany"](
            this.selected_company_id
        );
    },
  },
  methods: {
    getDialogAction(update_status, btn_icon, btn_color, method) {
        return {
            button_icon: btn_icon,
            button_color: btn_color,
            method: this[method],
            payload: update_status,
        };
    },
    async removeMember(member) {
      try {
        await this.$store.dispatch("company/removeMember", member);
        this.$emit('getMembers');
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.removed_member"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
  components: {
      AddMemberDialog,
      ConfirmationDialog
  }
};
</script>
